/**
 * Crank Config · live "Peso orientativo" readout for the Desarrollo/Medida/
 * Color add-on pickers (see snippets/crank-config-addons.liquid).
 *
 * Price never needs recomputing here: Desarrollo, Medida and Color do not
 * change price, so the native Shopify variant price (from Araña/Plato/Eje)
 * is already correct on its own.
 *
 * Weight = the selected TRUE variant's crank_config.weight_base_g metafield
 * (arm + spider + tornillería + plate-at-50/34T) + the ring-weight delta for
 * the selected Desarrollo, keyed by the variant's own Plato option value so
 * it always tracks the same plate the shopper is actually buying.
 */
(() => {
  if (window.raceitCrankConfig) return;
  const RING_WEIGHT_DELTA_G = {
    'Cybrei EVO PRO': { '50/34T': 0, '52/36T': 8, '54/38T': 16 },
    // Keep the former option value for saved carts and cached product data.
    'Cybrei EVO': { '50/34T': 0, '52/36T': 8, '54/38T': 16 },
    'Cybrei Metarbon': { '50/34T': 0, '52/36T': 17.5, '54/38T': 37.5 },
  };

  function formOf(root) {
    return document.getElementById(root.dataset.crankConfigForm) || root.closest('form');
  }

  function syncForm(form) {
    if (!form) return;
    const roots = [...document.querySelectorAll('[data-crank-config-root]')]
      .filter((root) => formOf(root) === form);
    if (!roots.length) return;
    // Read the same enabled, form-associated radios that FormData submits.
    // A second copy or an AJAX replacement must never retain its own defaults.
    const controls = [...form.elements];
    const selected = (selector) => controls.find((el) => el.matches(selector) && el.checked && !el.disabled)?.value || null;
    const ratio = selected('[data-crank-config-desarrollo]');
    const variantId = controls.find((el) => el.name === 'id')?.value;

    roots.forEach((root) => {
      const dataEl = root.querySelector('[data-crank-config-variants]');
      const weightValueEl = root.querySelector('[data-crank-config-weight-value]');
      if (!dataEl || !weightValueEl) return;

      let variants;
      try {
        variants = JSON.parse(dataEl.textContent);
      } catch {
        return;
      }

      const v = variantId != null ? variants[variantId] : null;
      if (!v || !ratio) {
        weightValueEl.textContent = '—';
        return;
      }
      const delta = RING_WEIGHT_DELTA_G[v.plato]?.[ratio] ?? 0;
      const total = v.w + delta;
      const formatted = Number.isInteger(total) ? total : total.toFixed(1);
      weightValueEl.textContent = `${formatted.toString().replace('.', ',')} g`;
    });
  }

  function syncAll() {
    const forms = new Set([...document.querySelectorAll('[data-crank-config-root]')].map(formOf));
    forms.forEach(syncForm);
  }

  window.raceitCrankConfig = { syncForm };
  document.addEventListener('change', (evt) => {
    const root = evt.target.closest?.('[data-crank-config-root]');
    if (root) syncForm(formOf(root));
    else if (evt.target.matches?.('input[name="id"]')) syncForm(evt.target.form);
  });
  document.addEventListener('submit', (evt) => syncForm(evt.target), true);
  document.addEventListener('DOMContentLoaded', syncAll);
  document.addEventListener('shopify:section:load', syncAll);
  document.addEventListener('on:variant:change', syncAll);
  if (document.readyState !== 'loading') syncAll();
})();
